import callApi from "../../Api";
import { saveAs } from 'file-saver';
import { ToastMessage, SUCCESS, ERROR } from "../../common/ToastMessage";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const REPORTS = "REPORTS"
export const ADMIN_REPORTS_DATA = "ADMIN_REPORTS_DATA";
export const RESET_REPORTS_DATA = "RESET_REPORTS_DATA"

export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});



export const downloadReportAction = (payload) => async (dispatch) => {
 
    try {
      dispatch(openLoader());
      const data = await callApi.get("admin/downloadReports",{params: payload});
      if (data.data.success) {
        dispatch(closeLoader());
        console.log(data.data.data)
        saveAs(data.data.data.url, data.data.data.name);
        // window.open(data.data.data, '_self');
        ToastMessage(SUCCESS, data.data.message);
        } else {
        ToastMessage(ERROR, data.data.message);
        dispatch(closeLoader());
      }
    } catch (error) {
      console.log("Error message",error)
      ToastMessage(ERROR, error);
      dispatch(closeLoader());
    }
};


export const getReportsAction = (payload) => async (dispatch) => {
    try {
      dispatch(openLoader());
      const data = await callApi.get("admin/reportsList",{params: payload});
      if (data.data.success) {
        dispatch(closeLoader());
        dispatch({
          type: ADMIN_REPORTS_DATA,
          payload: data.data.data
        });
        } else {
        ToastMessage(ERROR, data.data.message);
        dispatch(closeLoader());
      }
    } catch (error) {
      console.log("Error message",error)
      ToastMessage(ERROR, error);
      dispatch(closeLoader());
    }
};



export const resetReportData = (payload) => async (dispatch) => {
    dispatch({
      type: RESET_REPORTS_DATA,
      payload: {
        totalStudents:[],
        paymentCompleted:[],
        paymentDue:[]
      }
    });
};





